import React, { useState, useRef, useEffect, use } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MdOutlineDashboard } from "react-icons/md";
import { IoPersonOutline, IoReceiptOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { TbCalendarTime, TbClockPlus, TbReportAnalytics } from "react-icons/tb";
import { HiOutlineClipboardList, HiOutlineDotsHorizontal } from "react-icons/hi";
import { AnimatePresence, motion } from "framer-motion";
import { useUser } from "../../context/UserContext";
import { LuClipboardPlus } from "react-icons/lu";
import { usePendingRequests } from "../../context/PendingRequestContext";
import { usePendingCompOffRequests } from "../../context/PendingCompOffRequestContext";
import { usePendingCompPayRequests } from "../../context/PendingCompPayRequestContext";
import { usePendingPayslipRequests } from "../../context/PendingPaySlipRequestContext";
import axios from "axios";
import { HiOutlineBars3 } from "react-icons/hi2";
import { FaIndianRupeeSign } from "react-icons/fa6";
import api from "../../utils/api";

function HrBottomNavBar() {
  const { currentUser ,loading} = useUser();
  const userRole = currentUser?.role;
  const [showMore, setShowMore] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const { pendingCount, updatePendingCount } = usePendingRequests();
  const { pendingCompOffCount, updatePendingCompOffCount } = usePendingCompOffRequests();
  const { pendingCompPayCount, updatePendingCompPayCount } = usePendingCompPayRequests();
  const { pendingPayslipCount, updatePendingPayslipCount } = usePendingPayslipRequests();
  const [requests, setRequests] = useState(0);

  useEffect(() => {
    const fetchPendingCount = async () => {
      if (currentUser?.role === "MANAGER" && currentUser?.id) {
        try {
          const [leaveRes, compOffRes, compPayRes, payslipRes] = await Promise.all([   
            api.get(`/api/leaves/pending-count?managerId=${currentUser?.id}`),
            api.get(`/api/compoffs/pending-count?managerId=${currentUser?.id}`),
            api.get(`/api/comppay/pending-count?managerId=${currentUser?.id}`),
            api.get(`/payslip/approval/pending-count`)
          ]);
          updatePendingCount(leaveRes.data);
          updatePendingCompOffCount(compOffRes.data);
          updatePendingCompPayCount(compPayRes.data);
          updatePendingPayslipCount(payslipRes.data);
        } catch (error) {
          console.error("Error fetching pending count:", error);
        }
      }
    };

    if (!loading && currentUser) {
      fetchPendingCount();
      const interval = setInterval(fetchPendingCount, 300000);
      return () => clearInterval(interval);
    }
  }, [currentUser, loading, updatePendingCount, updatePendingCompOffCount, updatePendingCompPayCount, updatePendingPayslipCount]);

  useEffect(() => {
    setRequests(pendingCount + pendingCompOffCount + pendingCompPayCount + pendingPayslipCount);
  }, [pendingCount, pendingCompOffCount, pendingCompPayCount, pendingPayslipCount]);

  


  const navLinks = [
    {
      name: "Dashboard",
      link: "/hr/dashboard",
      icon: <MdOutlineDashboard className="text-2xl" />,
    },
    {
      name: "Employees",
      link: "/hr/employees",
      icon: <IoReceiptOutline className="text-2xl" />,
    },
    {
      name: "Annoucements",
      link: "/hr/events/annoucements",
      icon: <SlCalender className="text-2xl" />,
    },
    {
      name: "Holidays",
      link: "/hr/events/holidays",
      icon: <SlCalender className="text-2xl" />,
    }
  ];

  const extraLinks = [
     {
      name: "Daily Attendance",
      link: "/hr/daily-attendance",
      icon: <TbCalendarTime className="text-2xl" />,
    },
     {
      name: "Monthly Atttendance",
      link: "/hr/monthly-attendance",
      icon: <TbClockPlus className="text-2xl" />,
    },
    {
      name: "Leave Reports",
      link: "/hr/leave-reports",
      icon: <TbClockPlus className="text-2xl" />,
    },
     { name: "Leave Balance Reports", 
      link: "/hr/leave-balance-reports", 
      icon: TbClockPlus },
    {
      name: "Comp Off Reports",
      link: "/hr/compOff-reports",
      icon: <TbClockPlus className="text-2xl" />,
    }
    ,
    {
      name: "On Duty Reports",
      link: "/hr/onduty-reports",
      icon: <TbClockPlus className="text-2xl" />,
    }
  ];

  if (currentUser?.role === "MANAGER" && currentUser?.office==="SPC") {
      extraLinks.push({
        name: "Comp Requests",
        link: "/employee/comp-off-requests",
        icon: <LuClipboardPlus className="mr-2 text-2xl" />,
        badge: pendingCompOffCount > 0 ? pendingCompOffCount : null
      });

      extraLinks.push({
        name: "Leave Requests",
        link: "/employee/leave-requests",
        icon: <HiOutlineClipboardList className="mr-2 text-2xl" />,
        badge: pendingCount > 0 ? pendingCount : null
      });

      extraLinks.push({
        name: "Comp Pay Requests",
        link: "/employee/comp-pay-requests",
        icon: <FaIndianRupeeSign className="mr-2 text-2xl" />,
        badge: pendingCompPayCount > 0 ? pendingCompPayCount : null
      });

         
    }

  

  // Close on outside click
   useEffect(() => {
      const handleClickOutside = (event) => {

        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowMore(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showMore]);

  

  return (
    <div className="relative w-full h-full flex justify-center items-center">
      {/* Nav Bar */}
      <div className="flex justify-around items-center p-2 w-full h-full bg-slate-800 shadow-full">
        {navLinks.map((item, index) => (
          <NavLink
            key={index}
            to={item.link}
            className={({ isActive }) =>
              `flex flex-col items-center p-1.5 rounded-lg  transition-all duration-200
              ${isActive ? "text-white bg-slate-700 scale-110" : "text-gray-400 hover:text-white hover:bg-slate-700/50"}`
            }
          >
            <motion.span whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
              {item.icon}
            </motion.span>
          </NavLink>
        ))}

        {/* More Button + Dropdown */}
<div className="relative flex flex-col items-center" ref={dropdownRef}>
  <button
    onClick={() => setShowMore(!showMore)}
    className="flex flex-col items-center p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-slate-700/50 transition"
  >
    <motion.span whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
      <HiOutlineBars3 className="text-xl" />
    </motion.span>
    {requests > 0 && (
      <span className="absolute -top-2 -right-3 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
        {requests}
      </span>
    )}
  </button>

  {/* Popup Dropdown */}
  <AnimatePresence>
    {showMore && (
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        className="absolute bottom-16 -right-4   w-64 bg-slate-800 flex flex-col gap-2 text-white border border-gray-200 shadow-xl rounded-xl p-4 z-[100] text-sm"
      >
        {extraLinks.map((item, index) => (
          <button
            key={index}
            className="flex  gap-2 p-4 rounded-full hover:bg-slate-600 transition w-full"
            onClick={() => {
              setShowMore(false); // close dropdown after click
              navigate(item.link);
            }}
          >
            <span className="text-xl">{item.icon}</span>
            <span className="flex-1">{item.name}</span>
            {item.badge && (
                                <AnimatePresence>
                                  
                                    <motion.span
                                      key="badge-expanded" // Key for AnimatePresence
                                      className="ml-auto bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
                                      initial={{ opacity: 0, x: 20 }}
                                      animate={{ opacity: 1, x: 0, scale: item.badge > 0 ? 1 : 0 }}
                                      exit={{ opacity: 0, x: 20 }}
                                      transition={{ duration: 0.2 }}
                                    >
                                      {item.badge}
                                    </motion.span>
                                  
                                </AnimatePresence>
                              )}
          </button>
        ))}
      </motion.div>
    )}
  </AnimatePresence>
</div>

       </div>
    </div>
  );
}

export default HrBottomNavBar;
